module.exports = __webpack_public_path__ + "static/media/waste-management.4e3429ad.svg";